module.exports = __webpack_public_path__ + "images/category_lp/construction_equipment/assessment_achievements/3@2x_a2d0ea30ea447cb8aa7221f54035b401.png";